
import { createSelector } from '@ngrx/store';
import { selectDesign } from '../design.selector';
import { Tree } from '@design/models/trees.model';
import { adapter } from './trees.reducer';
import { TreesState } from './trees.state';

const { selectIds, selectEntities, selectAll, selectTotal } =
    adapter.getSelectors();

type SelectedEntitiesByIDProps = {
    id: Tree['id'];
};

export namespace fromTreesSelectors {

    export const treesStateSelector = createSelector(
        selectDesign,
        (state) => state.trees
    );

    export const allTrees = createSelector(
        treesStateSelector,
        selectAll
    );

    export const selectedTrees = createSelector(selectDesign, (state) => {

        const selectedId = state.ui.selectedObjectId;
        if (!selectedId) {
            return null;
        }

        const entities = state.trees.entities;
        return entities[selectedId];

    });

    export const selectedEntitiesByID =  (id: Tree['id']) =>  createSelector(
        treesStateSelector,
        (state: TreesState)=> {
            const entities = selectEntities(state);
            return  entities[id];
        }
    );

}
